<template>
  <section id="contact" class="contact">
    <div class="contact-content">
      <h2>Ready to Transform Your Sales Process?</h2>
      <p>Contact us for a free demo</p>
      <form class="contact-form" @submit.prevent="handleSubmit">
        <input v-model="form.name" type="text" placeholder="Full Name" required>
        <input v-model="form.email" type="email" placeholder="Work Email" required>
        <input v-model="form.company" type="text" placeholder="Company" required>
        <button type="submit" class="submit-button">Request Demo</button>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      form: {
        name: '',
        email: '',
        company: ''
      }
    }
  },
  methods: {
    handleSubmit() {
      console.log('Form submitted:', this.form)
      // Form gönderme mantığı buraya gelecek
    }
  }
}
</script>

<style scoped>
.contact {
  padding: 4rem 2rem;
  background: var(--light-bg);
}

.contact-content {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
}

.contact-form input {
  padding: 1rem;
  border-radius: var(--border-radius);
  border: 1px solid #e5e7eb;
}

.submit-button {
  padding: 1rem;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: var(--border-radius);
  font-weight: 600;
  cursor: pointer;
}
</style> 